<div class="cv-loader-component" *ngIf="isLoader">
	<div class="overlay-content">
		<div class="overlay-spinner__container" *ngIf="isSpinnerOn">
			<div class="loader__spinner"></div>
		</div>
		<div class="loader__message">
			{{message}} <br />
			<span *ngIf="!hideSubMessage">This action could take time, please wait.</span>
		</div>
	</div>
</div>
